var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:({
            content: _vm.name,
            disabled: !_vm.showPopoverName || !_vm.name,
        }),expression:"{\n            content: name,\n            disabled: !showPopoverName || !name,\n        }",modifiers:{"hover":true,"top":true}}],class:['tw-rounded-full', _vm.size, _vm.imgClasses],attrs:{"src":_vm.src,"alt":_vm.name,"loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }